export const BookSetupWizardDefaultFeatureFlag = {
  readonlyfor60days: false,
  react_report_template_updates_beta_company_logo_pdf_export: false,
  migration_financial_year_update: false,
};
